import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

type FormDatePickerProps<TDate = Dayjs> = DatePickerProps<TDate>;

export const FormDatePicker = <TDate = Dayjs>({
  slotProps,
  ...props
}: FormDatePickerProps<TDate>) => {
  const defaultSx = {
    '& .MuiInputBase-root': {
      height: 56,
      fontSize: '16px',
    },
    '& .MuiInputBase-input': {
      fontSize: '16px',
    },
    '& .MuiInputLabel-root': {
      fontSize: '16px',
    },
  };

  const textFieldSlotProps = slotProps?.textField as any;
  const mergedTextFieldProps = {
    size: 'medium' as const,
    fullWidth: true,
    sx: {
      ...defaultSx,
      ...(textFieldSlotProps?.sx || {}),
    },
    inputProps: {
      style: { fontSize: 16 },
      ...(textFieldSlotProps?.inputProps || {}),
    },
    ...textFieldSlotProps,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        {...props}
        slotProps={{
          ...slotProps,
          textField: mergedTextFieldProps,
        }}
      />
    </LocalizationProvider>
  );
};

